<div class="modal fade" id="mail-packet">
  <div class="modal-dialog modal-lg border shadow">
    <div class="modal-content">
      <div class="modal-body">
        <div class="messagecont" [formGroup]="mailTempalateForm">
          <div class="p-field p-col mb-0">
            <div class="row">
              <div class="col-lg-4 col-md-6 col-12 mb-3">
                <label aria-labelledby="mailpacket" for="mailpacket" class="intake-form-labels text-primary">
                  Page <span class="requiredfield text-danger">*</span>
                </label>
                <div class="p-0">
                  <p-dropdown styleClass="w-100" [options]="pageList" optionLabel="activeVersion.pagename"
                    optionValue="id" formControlName="page" placeholder="Select Page" (onChange)="changePage($event)">
                  </p-dropdown>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-12 mb-3">
                <label aria-labelledby="mailpacketReferral" for="mailpacketReferral"
                  class="intake-form-labels text-primary">Response id <span
                    class="requiredfield text-danger">*</span></label>
                <div class="col p-0">
                  <div class="input-group">
                    <input id="mailpacketReferral" class="form-control" formControlName="responseid" type="text"
                      maxlength="20" fieldKey="DOC_PAC_MAIL_PACKET_REFERRAL_ID" placeholder="Response Id"
                      (keyup)="onKeyUp($event)" autocomplete="off" pInputText />
                    <ul *ngIf="referralAutoSuggestion" class="autosuggest">
                      <li *ngFor="let item of referralAutoList" (click)="selectAddrss(item)">
                        {{ item?.id }}
                        {{ item?.client ? '-(' + (item?.client.firstName + ', ' + item?.client.lastName) + ')' : '' }}
                      </li>
                    </ul>
                  </div>
                  <small
                    *ngIf="mailTempalateFormControl.responseid.invalid && mailTempalateFormControl.responseid.touched"
                    class="p-error block">Response Id is required</small>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-12 mb-3">
                <label aria-labelledby="mailpacketName" for="mailpacketName"
                  class="intake-form-labels text-primary">Packet Name <span
                    class="requiredfield text-danger">*</span></label>
                <div class="col p-0">
                  <p-dropdown id="mailpacketName" styleClass="d-flex" [options]="document_packet_data"
                    fieldKey="DOC_PAC_MAIL_PACKET_SELECT_PACKET_NAME" optionLabel="name"
                    placeholder="Select Packet Name" formControlName="selectPacketName"
                    (onChange)="selectMailId($event.value)">
                  </p-dropdown>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-12 mb-3">
                <label aria-labelledby="mailpacketEmail" for="mailpacketEmail" class="intake-form-labels">Email ID <span
                    class="requiredfield text-danger">*</span></label>
                <div class="col p-0">
                  <input id="mailpacketEmail" class="form-control" oninput="this.value = this.value.toLowerCase()"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" formControlName="email" type="email"
                    fieldKey="DOC_PAC_MAIL_PACKET_EMAIL_ID" placeholder="Enter Email ID" pInputText />
                  <small *ngIf="mailTempalateFormControl.email.invalid && mailTempalateFormControl.email.touched"
                    class="p-error block">Email ID is required</small>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-12 mb-md-3 mb-4">
                <label aria-labelledby="mailpacketMailTemp" for="mailpacketMailTemp" class="intake-form-labels">
                  Mail Template <span class="requiredfield text-danger">*</span>
                </label>
                <div class="col p-0">
                  <p-dropdown id="mailpacketMailTemp" styleClass="d-flex" fieldKey="DOC_PAC_MAIL_PACKET_MAIL_TEMPLATE"
                    [options]="emailTemplate" optionLabel="name" placeholder="Select Template"
                    formControlName="selectTemplate" (onChange)="selectedTemp($event.value)">
                  </p-dropdown>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-12 mb-lg-3">
                <label class="intake-form-labels d-none d-md-none d-lg-block">&#160;</label>
                <p-checkbox [binary]="true" formControlName="convertToZip" fieldKey="DOC_PAC_MAIL_PACKET_CONVERT_TO_ZIP"
                  inputId="convert"></p-checkbox>
                <label for="convert" class="intake-form-labels pl-2 mb-0"> Convert To Zip </label>
              </div>

              <div class="col-lg-4 col-md-6 col-12 mb-lg-3">
                <label class="intake-form-labels d-none d-md-none d-lg-block">&#160;</label>
                <p-checkbox [binary]="true" formControlName="additionalDocuments"
                  fieldKey="DOC_PAC_MAIL_PACKET_CONVERT_TO_ZIP" inputId="additional">
                </p-checkbox>
                <label for="additional" class="intake-form-labels pl-2 mb-0"> Additional Documents </label>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="missingCategoryList?.length > 0">
          <ng-container>
            <div class="col-md-12 mt-4">
              <label for="client-name" class="intake-form-labels text-danger">The below category documents missing for
                this Form, Are sure you want to send a mail</label>
            </div>
            <table aria-describedby="Category_Table" class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Category</th>
                  <th scope="col">Sub Category</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let cat of getCategoryList(); let i = index">
                  <tr *ngFor="let subcat of getSubCategory(cat); let j = index">
                    <td>{{ cat?.category ? cat?.category : '' }}</td>
                    <td>{{ subcat ? subcat : '' }}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </ng-container>
        </div>
      </div>
      <div class="modal-footer">
        <div class="mt-2">
          <button class="pull-right mb-2 btn btn-primary btncommon text-uppercase" fieldKey="DOC_PAC_MAIL_PACKET_SEND"
            (click)="confirmPacketMail()">
            Send
          </button>
          <button
            class="pull-right mb-2 mr-2 btn btn-white border border-1 border-primary text-primary btncancel text-uppercase"
            fieldKey="DOC_PAC_MAIL_PACKET_CANCEL" (click)="closeMailPacket()">
            Cancel
          </button>
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</div>
